import { createEntityActionNames, createEntityActions } from "store/entities/actions";
import { ICustomView } from "store/entities/custom-views/interfaces";
import { ActionsUnion, createAction } from "store/helper";

export const CustomViewsActionsNames = {
  ...createEntityActionNames("CUSTOM_VIEW"),
  SYNC_DELETE: "ENTITIES/CUSTOM_VIEW/SYNC_DELETE",
};

export const CustomViewsActions = {
  ...createEntityActions<ICustomView>(CustomViewsActionsNames),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  syncDelete: (payload: { id: string }) => createAction(CustomViewsActionsNames.SYNC_DELETE, payload),
};

export type CustomViewsAction = ActionsUnion<typeof CustomViewsActions>;
